<template>
  <div class="learning-report">
    <div class="report-content">
      <div
        v-show="currentMode.name === 'bar-chart'"
        key="bar-chart"
        class="chart"
        ref="chartBar">
      </div>
      <transition-group name="fadeIn" mode="out-in">
        <div
          v-show="currentMode.name === 'area-chart'"
          key="area-chart"
          class="chart"
          ref="chartArea">
        </div>
        <div
          v-show="currentMode.name === 'pie-chart'"
          key="pie-chart"
          class="chart"
          ref="chartPie">
        </div>
        <div
          v-show="currentMode.name === 'calendar'"
          key="calendar"
          class="chart">
          <table>
            <colgroup>
              <col width="70px">
              <col width="255px">
              <col width="120px">
              <col width="65px">
              <col width="115px">
              <col width="85px">
            </colgroup>
            <thead>
              <tr>
                <th>测试类型</th>
                <th>单元</th>
                <th>测试时间</th>
                <th>测试耗时</th>
                <th>分数</th>
                <th>详情</th>
              </tr>
            </thead>
            <tbody v-if="testResultList.length" >
              <tr v-for="(item, index) in testResultList" :key="index">
                <td>{{item.testType}}</td>
                <td :title="item.unitName">{{item.unitName}}</td>
                <td>{{item.testTime}}</td>
                <td>{{item.timeConsuming}}</td>
                <td :title="item.score">{{item.score}}</td>
                <td class="detail">
                  <span @click="checkDetail(item)">查看详情</span>
                  <i class="icon iconfont icon-rewards"
                    v-if="item.trophyId"
                    @click="openCertificate(item)"></i>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="6">
                  <h4 class="no-result">[ 暂无测试成绩 ]</h4>
                </td>
              </tr>
            </tbody>
          </table>
          <el-pagination
            class="pagination"
            background
            layout="prev, pager, next"
            @current-change="handleCurrentPageChange"
            :total="total" />
        </div>
      </transition-group>
      <div class="controls">
        <template v-for="(mode, index) in modeList">
          <i
            :key="index"
            :data-title="mode.title"
            @click="toggleChart(index)"
            :class="`icon-${mode.name}`"
            class="icon iconfont">
          </i>
        </template>
      </div>
    </div>
    <VanCertificate
      v-if="isShowCertificate"
      @close="isShowCertificate = false"
      :is-replay="false"
      :info="userInfo" />
    <van-exam-dialog
      ref="examDialog"
      class="exam-dialog"
      :scene="5"
      :is-comparison="isComparison"
      :exercises="examQuizzes"
      :extend-exercises="afterExamQuizzes"
      :navigation="navigation"
      :scores="scores"
    />
  </div>
</template>

<script>
/* eslint-disable */
import echarts from 'echarts';
import api from '@/api/graphql/statistic';
import api1 from '@/api/graphql/englishCourse';
import utils from '@/services/utils';
import VanCertificate from '@/components/quizzes/bdc/Certificate.vue';
import VanExamDialog from '@/components/quizzes/bdc/ExamDialog.vue';
import { Pagination } from 'element-ui';

const wordCountOption = {
  toolbox: {
    right: '50',
    itemSize: 18,
    feature: {
      magicType: {
        show: true,
        type: ['line', 'bar'],
      },
      saveAsImage: {
        show: true,
      },
    },
  },
  title: {
    text: '【最近一周内单词学习单词数量图表】',
    left: 'center',
  },
  legend: {
    data: ['单词数量'],
    left: 'left',
  },
  xAxis: [],
  yAxis: [
    {
      type: 'value',
    },
  ],
  color: ['#409EFF'],
  series: [
    {
      name: '单词数量',
      type: 'bar',
      data: [],
      barWidth: 28,
      label: {
        show: true,
        position: 'top',
        textStyle: {
          fontSize: 16,
          fontWeight: 'bold',
          color: '#409EFF',
        },
      },
    },
  ],
};

const learningTimeOption = {
  toolbox: {
    right: '50',
    itemSize: 18,
    feature: {
      magicType: {
        show: true,
        type: ['line', 'bar'],
      },
      saveAsImage: {
        show: true,
      },
    },
  },
  title: {
    text: '【最近一周内学习时间图表】',
    left: 'center',
  },
  legend: {
    data: ['学习分钟'],
    left: 'left',
  },
  xAxis: [],
  yAxis: [
    {
      type: 'value',
    },
  ],
  color: ['#409EFF'],
  series: [
    {
      name: '学习分钟',
      type: 'bar',
      data: [],
      barWidth: 28,
      label: {
        show: true,
        position: 'top',
        textStyle: {
          fontSize: 16,
          fontWeight: 'bold',
          color: '#409EFF',
        },
      },
    },
  ],
};

const timeTotalOption = {
  title: {
    text: '',
    x: 'center',
  },
  legend: {
    orient: 'vertical',
    left: 'left',
    data: ['拼写类', '识别类'],
  },
  series: [
    {
      name: '学习时间统计',
      type: 'pie',
      radius: '70%',
      center: ['50%', '60%'],
      startAngle: 0,
      data: [],
      color: ['#ff6600', '#4bb2c5'],
      itemStyle: {
        normal: {
          label: {
            show: true,
            fontSize: 18,
            formatter: '{d}% \n {b}：{c}秒',
          },
        },
        emphasis: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)',
        },
      },
    },
  ],
};

export default {
  name: 'learning-report',
  props: {
    title: {
      type: String,
    },
    code: {
      type: String,
    },
  },
  watch: {
    code() {
      this.init();
    },
  },
  components: {
    VanCertificate,
    ElPagination: Pagination,
    VanExamDialog,
  },
  provide() {
    return {
      getUnitList: () => [],
      getCurrentUnitId: () => null,
    };
  },
  data() {
    return {
      modeList: [
        {
          name: 'bar-chart',
          type: 'Bar',
          title: '最近一周所学单词',
        },
        {
          name: 'area-chart',
          type: 'Area',
          title: '最近一周学习时间',
        },
        {
          name: 'pie-chart',
          type: 'Pie',
          title: '本月学习时间统计',
        },
        {
          name: 'calendar',
          type: 'Table',
          title: '测试成绩',
        },
      ],
      currentModeIndex: 0,
      testResultList: [],
      isShowCertificate: false,
      total: 0,
      downInfo: {},
      checkList: [1],
      examTypes: [],
      examQuizzes: [],
      afterExamQuizzes: [],
      scores: [],
      userInfo: {},
      navigation: '',
      isComparison: false,
    };
  },
  computed: {
    currentMode() {
      return this.modeList[this.currentModeIndex];
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.drawChart();
      this.getExamRecords();
    },
    handleCurrentPageChange(page) {
      this.getExamRecords(page);
    },
    checkDetail({ id, type, courseName, unitName, afterExamId }) {
      this.afterExamQuizzes = [];
      let promise;

      if (afterExamId) {
        this.isComparison = true;
        promise = api1.getDiffExamDetail({
          beforeExamId: id,
          afterExamId,
        });
      } else {
        this.isComparison = false;
        promise = api1.getExamDetail({
          examId: id,
        });
      }

      promise
        .then((response) => {
          const data = response.diffEnglishExamDetail || [response.englishExamDetail];
          const [beforeDetail, afterDetail] = data;
          const scores = [];

          scores.push(beforeDetail.score);
          this.examQuizzes = beforeDetail.quizzes.map((item) => {
            const userAnswer = item.userAnswer;
            return {
              ...item,
              userAnswer,
            };
          });

          if (afterDetail) {
            scores.push(afterDetail.score);
            this.afterExamQuizzes = afterDetail.quizzes.map((item) => {
              const userAnswer = item.userAnswer;
              return {
                ...item,
                userAnswer,
              };
            });
          }

          this.scores = scores;
          this.navigation = unitName;
          this.$refs.examDialog.open();
        });
    },
    openCertificate({ trophyId }) {
      api1.getExamDetail({
        examId: trophyId,
        type: 'comparison',
      }).then(({ englishExamDetail }) => {
        this.userInfo = {
          ...englishExamDetail,
          certificateId: trophyId,
        };
        delete this.userInfo.quizzes;
        this.isShowCertificate = true;
      });
    },
    toggleChart(index) {
      this.currentModeIndex = index;
    },
    getExamRecords(page = 1, size = 10) {
      api.getExamRecords({
        page,
        size,
        code: this.code,
      }).then((data) => {
        this.testResultList = data.examRecords.list;
        this.total = data.examRecords.total;
      });
    },
    drawChart() {
      this.drawWordCount();
      this.drawLearningTime();
      this.drawPieTimeTotal();
    },
    drawWordCount() {
      const barChart = echarts.init(this.$refs.chartBar);
      api.fetchStatistic({
        type: 'word',
        range: 'week',
        code: this.code,
      }).then((data) => {
        const dates = data.statistic.map(item => item.label);
        const count = data.statistic.map(item => item.value);
        wordCountOption.xAxis = {
          data: dates,
        };
        wordCountOption.series[0].data = count;
        barChart.setOption(wordCountOption);
      });
    },
    drawLearningTime() {
      const barChart = echarts.init(this.$refs.chartArea);
      api.fetchStatistic({
        type: 'time',
        range: 'week',
        code: this.code,
      }).then((data) => {
        const dates = data.statistic.map(item => item.label);
        const seconds = data.statistic.map(item => item.value);
        learningTimeOption.xAxis = {
          data: dates,
        };
        learningTimeOption.series[0].data = seconds;
        barChart.setOption(learningTimeOption);
      });
    },
    drawPieTimeTotal() {
      const pieChart = echarts.init(this.$refs.chartPie);
      api.fetchSpecificStatistic({
        type: 'time',
        range: 'month',
        code: this.code,
      }).then((data) => {
        /* eslint-disable */
        let total = 0;
        const timeInfo = data.specificStatistic.map((item) => {
          total += item.value;
          return {
            value: item.value,
            name: item.label,
          };
        });
        timeTotalOption.series[0].data = timeInfo;
        timeTotalOption.title.text = `【本月学习时间统计（总计：${total}秒）】`;
        pieChart.setOption(timeTotalOption);
      });
    },
    getExamTypes() {
      api.getExamTypes({
        type: 'download',
      }).then((data) => {
        this.examTypes = data.examTypes;
      });
    },
    downTest() {
      /* eslint-disable */
      const token = utils.storage('token');
      const url = `/api/home/test/get/export?test_id=${this.downInfo.id}&test_type=${this.checkList.join(',')}&token=${token}`;
      window.location.href = utils.getApiPath(url);
      this.$refs.dialog.close();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.learning-report {
  width: 100%;
  .report-content {
    .chart {
      padding-top: 30px;
      width: 1200px;
      height: 650px;
      margin: 0 auto;
      table {
        border: 1px solid #ddd;
        width: 100%;
	      table-layout:fixed;
        margin-bottom: 20px;
        border-collapse: collapse;
        background-color: transparent;
        td {
          height: 35px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        thead {
          background: #95a0aa;
          color: #ebebeb;
          vertical-align: middle;
          tr {
            height: 40px;
            vertical-align: inherit;
            border-color: inherit;
            th {
              padding: 0 8px;
              line-height: 40px;
              font-weight: 700;
              font-size: 16px;
              text-align: center;
            }
          }
        }
        tbody {
          td {
            padding: 10px;
            border: solid #d3d1d1;
            border-width: 0 1px 1px 0;
            font-size: 13px;
            text-align: center;
            font-family: 微软雅黑, 黑体, 宋体, Arial软;
            color: #4d4d4d;
            &:hover {
              background-color: #f5f5f5;
            }
            .no-result {
              margin: 10px 0;
              color: #f93;
              font-weight: 500;
              font-size: 18px;
            }
            &:last-child {
              cursor: pointer;
            }
          }
          .detail {
            position: relative;
            .icon-rewards {
              position: absolute;
              top: 50%;
              right: 6px;
              transform: translateY(-54%);
              font-size: 20px;
              color: $primary;
            }
          }
        }
        .test {
          &:hover {
            cursor: pointer;
          }
        }
        .success {
          color: $success!important;
        }
        .fail {
          color: $danger!important;
        }
      }
      .read-more {
        display: block;
        width: 100%;
        text-align: center;
        color: #00b29f;
        text-decoration: none;
        cursor: pointer;
      }
    }
    .controls {
      // margin-top: 10px;
      text-align: right;
      i {
        margin-right: 15px;
        font-size: 45px;
        color: $primary;
        position: relative;
        cursor: pointer;
          &:hover {
            opacity: 0.8;
          }
          &:after {
            display: inline-block;
            padding: 2px 4px;
            font-size: 12px;
            border: 1px solid #4d4d4d;
            color: #4d4d4d;
            white-space:nowrap;
            content: attr(data-title);
            position: absolute;
            bottom: -15px;
            left: 0;
            opacity: 0;
            box-shadow: 1px 1px 2px rgb(112, 112, 112);
            transition: all .5s .3s;
          }
          &:hover:after {
            opacity: 1;
          }
      }
      .icon-bar-chart {
        position: relative;
      }
    }
    .pagination {
      position: absolute;
      bottom: 50px;
    }
  }
  .report-dialog {
    /deep/ .el-dialog__footer {
      display: none!important;
    }
  }
  .exam-dialog {
    /deep/ .el-dialog {
      width: 90vw!important;
      height: 88vh!important;
      .exam  {
        .bdc-exam-dialog-wrap {
          height: 80vh!important;
          overflow: hidden!important;
          .article-exam-wrapper {
            height: 77vh;
            .article-exam-detail {
              height: 100%;
            }
          }
        }
        .footer-bar {
          display: none;
        }
        .ydlj-container {
          .article-wrap {
            width: 100%!important;
          }
          .list-wrap {
            width: 100%!important;
          }
        }
      }
    }
  }
}
.download-dialog {
  font-size: 16px;
  .el-dialog {
    width: 700px!important;
  }
  .title {
    text-align: center;
  }
  .content {
    .checkbox-type {
      margin-top: 40px;
    }
    .checkbox {
      margin: 30px 0 0 15px;
    }
  }
  .footer {
    text-align: right;
  }
  .el-checkbox__label {
    font-size: 16px;
  }
}
.fadeIn-enter-active{
  transition: opacity .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.fadeIn-leave {
  display: none;
}
.fadeIn-enter{
  opacity: 0;
}
@media screen and (max-device-height: 1079px){
  .chart {
    width: 945px!important;
    height: 460px!important;
    table {
      td {
        height: 20px!important;
      }
    }
    .pagination {
      position: absolute;
      bottom: 7px!important;
    }
  }
}
</style>
